var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HelloWorld'),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('Foot'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footbox df"},[_c('img',{staticClass:"img1",attrs:{"src":require("./assets/img/dnzx.png"),"alt":""}}),_c('img',{staticClass:"img2",attrs:{"src":require("./assets/img/sj1.png"),"alt":""}})])
}]

export { render, staticRenderFns }